import { useCallback } from 'react'
import { isEmpty } from 'lodash'

export default function useLocalSearch(data, searchField) {
  const fetch = useCallback(
    term => {
      if (!data) return []
      if (isEmpty(term)) return data
      return data.filter(value =>
        value[searchField].toLowerCase().includes(term.toLowerCase())
      )
    },
    [data, searchField]
  )

  return fetch
}
